import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AppStore } from '../stores/app-store';
import { GuestAccessStore } from '../stores/guest-store';
import {TokenService} from "../pages/auth/services/token.service";

export const AuthGuard: CanActivateFn = (route) => {
  const store = inject(AppStore);
  const router = inject(Router);
  const tokenService = inject(TokenService);

  if (route.queryParams['plot']) {
    store.initialPlotUUID.value = route.queryParams['plot'];
  }

  const guestState = GuestAccessStore.getState();

  if (
    (tokenService.checkToken() && !guestState.enabled) ||
    (guestState.token && guestState.enabled)
  ) {
    return true;
  } else {
    router.navigate(['auth']);
    return false;
  }
};
